import { render, staticRenderFns } from "./correlationRatio_see.vue?vue&type=template&id=65bcaa5b&scoped=true"
import script from "./correlationRatio_see.vue?vue&type=script&lang=js"
export * from "./correlationRatio_see.vue?vue&type=script&lang=js"
import style0 from "./correlationRatio_see.vue?vue&type=style&index=0&id=65bcaa5b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bcaa5b",
  null
  
)

export default component.exports